/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialogue_List_Export_More_OptionsInputs */

const en_dialogue_list_export_more_options = /** @type {(inputs: Dialogue_List_Export_More_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`More Options`)
};

const fr_dialogue_list_export_more_options = /** @type {(inputs: Dialogue_List_Export_More_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus d'options`)
};

const de_dialogue_list_export_more_options = /** @type {(inputs: Dialogue_List_Export_More_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weitere Optionen`)
};

const it_dialogue_list_export_more_options = /** @type {(inputs: Dialogue_List_Export_More_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Altre opzioni`)
};

const ru_dialogue_list_export_more_options = /** @type {(inputs: Dialogue_List_Export_More_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Дополнительные варианты`)
};

const es_dialogue_list_export_more_options = /** @type {(inputs: Dialogue_List_Export_More_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Más opciones`)
};

const zh_cn2_dialogue_list_export_more_options = /** @type {(inputs: Dialogue_List_Export_More_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`更多选项`)
};

const ja_dialogue_list_export_more_options = /** @type {(inputs: Dialogue_List_Export_More_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`その他のオプション`)
};

const hi_dialogue_list_export_more_options = /** @type {(inputs: Dialogue_List_Export_More_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अधिक विकल्प`)
};

const pt_pt2_dialogue_list_export_more_options = /** @type {(inputs: Dialogue_List_Export_More_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mais opções`)
};

/**
* | output |
* | --- |
* | "More Options" |
*
* @param {Dialogue_List_Export_More_OptionsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const dialogue_list_export_more_options = /** @type {((inputs?: Dialogue_List_Export_More_OptionsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialogue_List_Export_More_OptionsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_dialogue_list_export_more_options(inputs)
	if (locale === "de") return de_dialogue_list_export_more_options(inputs)
	if (locale === "it") return it_dialogue_list_export_more_options(inputs)
	if (locale === "ru") return ru_dialogue_list_export_more_options(inputs)
	if (locale === "es") return es_dialogue_list_export_more_options(inputs)
	if (locale === "zh-CN") return zh_cn2_dialogue_list_export_more_options(inputs)
	if (locale === "ja") return ja_dialogue_list_export_more_options(inputs)
	if (locale === "hi") return hi_dialogue_list_export_more_options(inputs)
	if (locale === "pt-PT") return pt_pt2_dialogue_list_export_more_options(inputs)
	return en_dialogue_list_export_more_options(inputs)
});